<template lang="pug">
  div
    .empty.my-2(v-if="!current.plantas || !current.plantas.length")
      .empty-icon
        i.fa.fa-map.fa-5x
      .empty-subtitle Nenhuma planta encontrada
    .columns.col-oneline.mt-1.images(v-else v-viewer="imageOptions")
      .column.col-2.col-md-4.col-sm-6.col-xs-12(v-for="planta in current.plantas" :key="planta.id" v-viewer)
        img.img-responsive.c-hand(:src="planta.thumb" :data-src="planta.url")
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/show'

export default {
  vuex: { cadastros: vuexDefaultMapping },
  data() {
    return { imageOptions: { url: 'data-src' } }
  },
}
</script>
